import Translate from '@components/atoms/Translate/Translate'

import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import Step from '../Step'
import styles from './HeaderSteps.module.scss'

const HeaderSteps = () => {
  const { currentStep, stepsFinished } = useSelector((state) => state.app)
  const steps = {
    0: 'header.step.0',
    1: 'header.step.1',
    2: 'header.step.2',
  }

  const stepsJsx = useMemo(
    () =>
      Object.keys(steps).map((id) => (
        <Step
          active={currentStep === parseInt(id)}
          stepNumber={parseInt(id) + 1}
          finished={stepsFinished > parseInt(id)}
          available={stepsFinished >= parseInt(id)}
          key={id}
        >
          <Translate str={steps[id]} />
        </Step>
      )),
    [currentStep, stepsFinished]
  )

  return (
    <div className={styles.base}>
      <div className={styles.steps}>{stepsJsx}</div>
    </div>
  )
}

export default HeaderSteps
